'use client';

import { useEffect, useState } from 'react';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Heading } from '@tiptap/extension-heading';
import { History } from '@tiptap/extension-history';
import { Image } from '@tiptap/extension-image';
import { Italic } from '@tiptap/extension-italic';
import { ListItem } from '@tiptap/extension-list-item';
import { Mention } from '@tiptap/extension-mention';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { BubbleCustomMenu } from './BubbleCustomMenu';
import { CustomCode } from './CustomCode';
import CustomImage from './CustomImage';
import { CustomMenu } from './CustomMenu';
import { Dropzone } from './Dropzone';

export const Editor = ({
  setEditorContent,
  content,
}: {
  setEditorContent?: (content: string) => void;
  content?: any;
}) => {

  const [opened, { open, close }] = useDisclosure(false);
  const [editorImageUrl, setEditorImageUrl] = useState<string | null>(null);

  const editor = useEditor({
    extensions: [
      // Use individual extensions instead of StarterKit
      Document,
      Paragraph,
      Text,
      Bold,
      Italic,
      History,
      Heading,
      // Other extensions
      CustomCode, // Our custom code extension
      Image.configure({ inline: false }),
      CustomImage,
      Blockquote,
      Underline,
      HardBreak,
      BulletList,
      OrderedList,
      ListItem,
      Mention,
    ],
    content: content ?? '',
    onUpdate: ({ editor }) => {
      try {
        setEditorContent && setEditorContent(editor.getHTML());
      } catch (error) {
        console.error('Error updating editor content:', error);
      }
    },
  });

  useEffect(() => {
    try {
      if (editorImageUrl && editor) {
        editor.chain().focus().setImage({ src: editorImageUrl }).run();
      }
    } catch (error) {
      console.error('Error setting image:', error);
    }
  }, [editorImageUrl, editor]);

  return (
    <div style={{ marginBottom: '20px' }}>
      <CustomMenu editor={editor} open={open} />
      <BubbleCustomMenu editor={editor} />
      <EditorContent editor={editor} />
      <Modal opened={opened} onClose={close} title="Upload image">
        <Dropzone setImageUrl={setEditorImageUrl} imageUrl={editorImageUrl} />
      </Modal>
    </div>
  );
};
